import styled from 'styled-components';

// Container do Thing — flat (sem bg/borda; herda da Section pai).
// padding 0 + height 100%: a imagem (ImageMapper, dimensionada pelo
// tamanho medido do wrapper) preenche o SceneFrame inteiro, sem moldura
// lateral/cinza. Antes o padding 14/18/16 criava a borda interna.
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  /* height auto: a coluna acompanha a altura natural da imagem (sem
     forcar 100% de um quadro de altura fixa). */
  height: auto;
  padding: 0;
  box-sizing: border-box;
`;

export const Line = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.center ? 'center' : 'space-between')};
  max-width: ${(props) => props.maxWidth ? props.maxWidth : "57.09vw"};
  max-height: ${(props) => props.maxHeight ? props.maxHeight : "64.06vh"};
  min-width: ${(props) => props.minWidth ? props.minWidth : ""};
  min-height: ${(props) => props.minHeight ? props.minHeight : ""};


  @media (max-width: 850px) {
    min-height: "";
    max-height: ${(props) => props.maxHeightMedia ? props.maxHeightMedia : "200px"};
  }
  
  #box {
    font-size: 12px;
    display: flex;
    font-weight: 700;
  }

  #thing {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Bar = styled.div`
  width: 40px;
  height: 10px;
  background: ${(props) => props.theme.colors.blue};
  border-radius: 10px;
  margin: auto;
`;

export const Block = styled.div`
  min-width: 50px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 15px;
  cursor: pointer;
  color: ${(props) => props.color};
  font-weight: bold;
  background: ${(props) => props.background};
  transition: all 0.2s;

  ${(props) => props.disabled && 'cursor: not-allowed'};
`;

export const ImageMapperWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  position: relative;
  ${(props) =>
    props.overlayed && `z-index: 3; border: 1px solid ${props.theme.colors.disabled};`};
  ${(props) => props.pointer && 'cursor:pointer; * {cursor:pointer;}'};
`;

export const Pin = styled.div`
  position: absolute;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  border: 1px solid ${(props) => props.theme.colors.card};
  background: ${(props) => props.theme.colors.green};
  z-index: ${(props) => (props.$dragging ? 10 : 3)};
  left: ${(props) => props.coords.x - 8}px;
  top: ${(props) => props.coords.y - 8}px;
  /* $draggable: cursor de mover quando o pin pode ser reposicionado.
     $dragging: feedback durante o arrasto (cresce + sombra). */
  user-select: none;
  touch-action: none;
  cursor: ${(props) =>
    props.$dragging ? 'grabbing' : props.$draggable ? 'grab' : 'default'};
  transform: ${(props) => (props.$dragging ? 'scale(1.4)' : 'scale(1)')};
  box-shadow: ${(props) =>
    props.$dragging ? '0 2px 8px rgba(0, 0, 0, 0.35)' : 'none'};
  transition: transform 120ms ease, box-shadow 120ms ease;
`;

export const ArrowContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.white};
  font-size: 20px;
  font-weight: 100;
  width: 125px;
  height: 125px;
  border-radius: 50%;
  background: ${(props) => props.theme.colors.lightblue};
  margin: 0 -85px;
`;

export const Label = styled.div`
  color: ${(props) => props.color};
  font-size: ${(props) => (props.size ? props.size : '16px')};
  font-weight: bold;
  margin: 0 10px;

  ${(props) =>
    props.left ? 'margin-right: auto' : props.right && 'margin-left: auto'};
  ${(props) => props.isName && 'text-transform: uppercase'};
`;

export const FloaterWrapper = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr;
  padding: 5px 10px;
  border-radius: 6px;
  transition: all 270ms;
  border: 1px solid transparent;
  grid-template-areas:
    'a a a a'
    'b b b b';

  > label {
    text-align: center;
    grid-area: a;
    font-size: 14px;
    transition: all 270ms;
  }
  > h4 {
    grid-area: b;
    font-size: 13px;
    font-weight: 900;
    margin: 0 5px;
    text-align: center;
    line-height: 20px;
  }
  img {
    width: 0px;
    height: 0px;
    margin: auto;
  }
  > button {
    cursor: pointer;
    background: transparent;
    display: flex;
    align-items: center;
  }
  :hover {
    grid-template-areas:
      'a a a a'
      'c b b d';

    img {
      transition: all 270ms;
      width: 20px;
      height: 20px;
    }
    button {
      width: 20px;
      height: 20px;
    }
  }
  ${(props) => props.highlight && `border: 1px solid ${props.theme.colors.red}`}
`;

export const SelectVariableWrapper = styled.div`
  display: flex;
  flex-direction: column;

  button {
    padding: 5px 15px;
    cursor: pointer;
    transition: all 270ms;
    color: ${(props) => props.theme.colors.darkblue};
    :hover {
      background: ${(props) => props.theme.colors.darkblue};
      color: ${(props) => props.theme.colors.white};
    }
  }

  label {
    text-align: center;
    font-size: 15px;
    color: inherit;
  }
`;
